import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useMedia } from '@calendly/hooks'
import _SignUpInnerWrapper from "styles-SignUpInnerWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability_signup/styles.js?styleId=SignUpInnerWrapper";
import _SignUpPanel from "styles-SignUpPanel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability_signup/styles.js?styleId=SignUpPanel";
import _SignUpHeader from "styles-SignUpHeader.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability_signup/styles.js?styleId=SignUpHeader";
import _SignUpTitle from "styles-SignUpTitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability_signup/styles.js?styleId=SignUpTitle";
import _SignUpContent from "styles-SignUpContent.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/mutual_availability_signup/styles.js?styleId=SignUpContent";

const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'

export const SignUpInnerWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "SignUpInnerWrapper",
  styles: _SignUpInnerWrapper
})
export const SignUpPanel = /*#__PURE__*/styled('div', null, {
  displayName: "SignUpPanel",
  styles: _SignUpPanel
})
export const SignUpHeader = /*#__PURE__*/styled('div', null, {
  displayName: "SignUpHeader",
  styles: _SignUpHeader
})
export const SignUpTitle = /*#__PURE__*/styled('div', null, {
  displayName: "SignUpTitle",
  styles: _SignUpTitle,
  attrs: props => ({
    ...props,
    isTablet: useDeviceType('isTablet'),
    isLargeScreen: useMedia({
      maxWidth: 1259
    }, false)
  })
})
export const SignUpContent = /*#__PURE__*/styled('div', null, {
  displayName: "SignUpContent",
  styles: _SignUpContent
})
